import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const CalendarCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const processCallback = async () => {
      const code = searchParams.get("code");
      const state = searchParams.get("state");
      const errorParam = searchParams.get("error");

      if (errorParam) {
        setError(`Google hatası: ${errorParam}`);
        setTimeout(() => navigate("/ayarlar?calendar_error=" + errorParam), 2000);
        return;
      }

      if (!code) {
        setError("Yetkilendirme kodu bulunamadı");
        setTimeout(() => navigate("/ayarlar?calendar_error=no_code"), 2000);
        return;
      }

      try {
        // Send code to backend to exchange for tokens
        await axios.post(
          `${API}/calendar/exchange`,
          { code, state },
          { withCredentials: true }
        );
        
        // Redirect to settings with success
        navigate("/ayarlar?calendar_connected=true");
      } catch (err) {
        console.error("Calendar callback error:", err);
        const errorMsg = err.response?.data?.detail || "Bağlantı hatası";
        setError(errorMsg);
        setTimeout(() => navigate("/ayarlar?calendar_error=" + encodeURIComponent(errorMsg)), 2000);
      }
    };

    processCallback();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#E8F3EE] via-white to-[#E8F3EE]">
      <div className="bg-white p-8 rounded-2xl shadow-lg text-center max-w-md">
        {error ? (
          <>
            <div className="text-red-500 text-lg font-medium mb-2">Hata</div>
            <p className="text-gray-600">{error}</p>
            <p className="text-sm text-gray-400 mt-4">Ayarlar sayfasına yönlendiriliyorsunuz...</p>
          </>
        ) : (
          <>
            <Loader2 className="w-12 h-12 text-[#1A4D2E] animate-spin mx-auto mb-4" />
            <p className="text-gray-600">Google Calendar bağlanıyor...</p>
          </>
        )}
      </div>
    </div>
  );
};

export default CalendarCallback;
